import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Box from './Box';
import { Spin } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import INSTALLER_QUERY from '../../graphql/installers/queries';


const PatchSays = styled.p`
  color: pink;
  font-family: LexiaAd;
  font-size: 2em;
  margin-bottom: 0px;
`;
const PatchMessage = styled.span`
  font-size: 1.2em
`;

const InstallModal = ({ longBuild, status, errorMessage }) => {

  const [patchMessage, setPatchMessage] = useState('');

  let value = null;
  let bottomText = '';


  const { loading, data } = useQuery(INSTALLER_QUERY.GET_PATCH_MESSAGE, {
    fetchPolicy: 'network-only',
    pollInterval: 5000
  });
  if (!loading && data){
    let message = data.getPatchMessageResponse[0]?.message;
    if (patchMessage != message){
      setPatchMessage(data.getPatchMessageResponse[0]?.message);
    }
  }

  switch (status) {
  case 'error':
    value = <PatchMessage>{errorMessage || 'There was an error generating the files. Please try again.'}</PatchMessage>;
    bottomText = 'Don’t forget to make sure your Bacon Data is correct before installing.';
    break;
  case 'loading':
    value = (<>
      <PatchSays>
        Patch says...
      </PatchSays>
      <PatchMessage>{patchMessage}</PatchMessage><Spin size="large" style={{marginTop:'25px'}}/></>);
    bottomText = longBuild ? 'Please allow up to 2 minutes for build to complete.' : '';
    break;
  case 'complete':
    value = (
      <>
        <PatchSays>Build completed!</PatchSays>
      </>
    );
    bottomText = 'Don’t forget to request a license key from the Bacon team! Contact admin@baconunlimited.com.';
    break;
  }

  return (<div>
    <Box
      status={status}
      bottomText={bottomText}
    >
      {value}
    </Box>

  </div>);
};

InstallModal.propTypes = {
  longBuild: PropTypes.bool,
  status: PropTypes.string.isRequired,
  errorMessage: PropTypes.string
};

InstallModal.defaultProps = {
  longBuild: true,
  errorMessage:''
};

export default InstallModal;